import { render, staticRenderFns } from "./editCategory.vue?vue&type=template&id=66c5fd92&"
import script from "./editCategory.vue?vue&type=script&lang=ts&"
export * from "./editCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports